// const body = document.querySelector('body')

// 	const header = document.querySelector('#main-header')
// 	const menuButton = document.querySelector('.menu-button')
// 	const menuRegion = document.querySelector('#header-menu')
// 	const searchButton = document.querySelector('.search-button')
// 	const searchRegion = document.querySelector('#header-search')
			
// 	menuButton.addEventListener('click', () => {
// 		const headerMenu = header.classList.contains('main-header--menu')
// 		const headerSearch = header.classList.contains('main-header--search')

// 		if (!headerMenu) {
// 			menuRegion.style.display = "block"
// 			menuRegion.style.zIndex = "-1"
// 			menuButton?.setAttribute('aria-expanded', true)
// 			body?.classList.add('body-block')

			
// 			setTimeout(function(){
// 				header?.classList.add('main-header--menu')
// 				menuRegion?.classList.add('active')
// 			},10)
// 			setTimeout(function(){
// 				searchButton?.setAttribute('aria-expanded','false')
// 				header?.classList.remove('main-header--search')
// 				searchRegion?.classList.remove('active')
// 				searchRegion.style.display = "none"
// 				menuRegion.style.zIndex = ""
// 			},500)
			
// 		} else {
// 			header?.classList.remove('main-header--menu')
// 			body?.classList.remove('body-block')
// 			menuButton?.setAttribute('aria-expanded', false)
// 			menuRegion?.classList.remove('active')

// 			searchButton?.setAttribute('aria-expanded','false')
// 			header?.classList.remove('main-header--search')
// 			searchRegion?.classList.remove('active')
// 			setTimeout(function(){
// 				menuRegion.style.display = "none"
// 				searchRegion.style.display = "none"
// 			},500)
// 		}
// 	})
// 	searchButton.addEventListener('click', () => {
// 		const headerMenu = header.classList.contains('main-header--menu')
// 		const headerSearch = header.classList.contains('main-header--search')
// 		if (!headerSearch) {
// 			searchRegion.style.display = "block"
// 			searchButton?.setAttribute('aria-expanded', true)
// 			searchRegion?.classList.add('active')
// 			body?.classList.add('body-block')
// 			setTimeout(function(){
// 				header?.classList.add('main-header--search')
// 			},10)
// 			searchRegion.focus()
// 		}else if (headerMenu){
// 			searchButton?.setAttribute('aria-expanded',false)
// 			header?.classList.remove('main-header--search')
// 			searchRegion?.classList.remove('active')
// 			setTimeout(function(){
// 				searchRegion.style.display = "none"
// 			},500)

// 		} else {
// 			header?.classList.remove('main-header--menu')
// 			body?.classList.remove('body-block')
// 			menuButton?.setAttribute('aria-expanded', false)
// 			menuRegion?.classList.remove('active')

// 			searchButton?.setAttribute('aria-expanded','false')
// 			header?.classList.remove('main-header--search')
// 			searchRegion?.classList.remove('active')
// 			setTimeout(function(){
// 				menuRegion.style.display = "none"
// 				searchRegion.style.display = "none"
// 			},5000)
// 		}

// 	})